import { render, staticRenderFns } from "./operationArea.vue?vue&type=template&id=6874b1a8&scoped=true"
import script from "./operationArea.vue?vue&type=script&lang=js"
export * from "./operationArea.vue?vue&type=script&lang=js"
import style0 from "./operationArea.vue?vue&type=style&index=0&id=6874b1a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6874b1a8",
  null
  
)

export default component.exports